export type LinkData = {
  id: number;
  name: string;
  anchor: string | null;
};

type HxValsMessageOld = {
  action: "game_msg";
  msg: {
    Move?: {
      id: number;
      name: string;
      anchor: string | null;
      cached?: boolean;
    };
    PreloadMove?: {
      id: number;
      name: string;
      anchor: string | null;
    };
  };
};

type HxValsMessage = {
  id: number;
  name: string;
  anchor?: string | null;
};

function isValidMessage(vals: unknown): vals is HxValsMessage {
  return (
    typeof vals === "object" &&
    vals !== null &&
    typeof (vals as HxValsMessage).id === "number" &&
    typeof (vals as HxValsMessage).name === "string" &&
    ((vals as HxValsMessage).anchor === undefined ||
      (vals as HxValsMessage).anchor === null ||
      typeof (vals as HxValsMessage).anchor === "string")
  );
}
function isValidMessageOld(vals: unknown): vals is HxValsMessageOld {
  return (
    typeof vals === "object" &&
    vals !== null &&
    "msg" in vals &&
    (vals as HxValsMessageOld).action === "game_msg"
  );
}

export function extractMoveData(hxVals: string): LinkData | null {
  if (!hxVals) return null;

  try {
    const vals = JSON.parse(hxVals);
    // FIXME: remove old move type
    if (isValidMessageOld(vals)) {
      const move = vals.msg.Move;
      if (!move) return null;
      return {
        id: move.id,
        name: move.name,
        anchor: move.anchor,
      };
    }
    if (isValidMessage(vals)) {
      return {
        id: vals.id,
        name: vals.name,
        anchor: vals.anchor ?? null,
      };
    }
    return null;
  } catch {
    console.error("Error parsing hx-vals:", hxVals);
    return null;
  }
}

export function extractArticleId(hxVals: string): number | null {
  const data = extractMoveData(hxVals);
  return data?.id ?? null;
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest;

  describe("messageParser", () => {
    const validHxVals = JSON.stringify({
      action: "game_msg",
      msg: {
        Move: {
          id: 123,
          name: "Test Article",
          anchor: "section-1",
        },
      },
    });

    it("extractMoveData returns parsed data", () => {
      const result = extractMoveData(validHxVals);
      expect(result).toEqual({
        id: 123,
        name: "Test Article",
        anchor: "section-1",
      });
    });

    it("extractMoveData returns null for invalid JSON", () => {
      expect(extractMoveData("not json")).toBeNull();
    });

    it("extractMoveData returns null for empty string", () => {
      expect(extractMoveData("")).toBeNull();
    });

    it("extractMoveData returns null for wrong action", () => {
      const invalid = JSON.stringify({
        action: "other_action",
        msg: { Move: { id: 1, name: "Test", anchor: null } },
      });
      expect(extractMoveData(invalid)).toBeNull();
    });

    it("extractArticleId returns id", () => {
      expect(extractArticleId(validHxVals)).toBe(123);
    });

    it("extractArticleId returns null for invalid", () => {
      expect(extractArticleId("invalid")).toBeNull();
    });
  });
}
